import { BaseDataService } from './BaseDataService';
import { Language } from '../../models';
import { NotificationService } from '../../services';

export class LanguageDataService extends BaseDataService<Language> {
    constructor(notificationService: NotificationService) {
        super('Language', 'Languages', notificationService);
    }
}


// WEBPACK FOOTER //
// ./src/services/api/LanguageData.tsx